// extracted by mini-css-extract-plugin
module.exports = {"cts-deposit-message":"deposit_message_style_cts-deposit-message__1VrHK"};